import { Link } from 'react-router-dom';
import { SearchBar } from '../components/search/SearchBar';
import { PROFILE_LABEL, type Profile } from '../types/profile';
import { profileHomePath } from '../lib/routes';

const profileCopy: Record<Profile, string> = {
  student: 'Diagnóstico, desenvolvimento, Jornada, Formações, Treinamentos, Evidências e Mentorias.',
  mentor: 'Experiência do Aluno + acompanhamento de Mentorados, Evidências e Mentorias.',
  owner: 'Aluno + Mentor + administração de pessoas, metodologia, conteúdo, Jornadas e Formações.',
};

export function HomePage({ onChooseProfile }: { onChooseProfile: (profile: Profile) => void }) {
  const profiles: Profile[] = ['student', 'mentor', 'owner'];

  return (
    <main>
      <section className="hero">
        <div className="page-shell hero-inner">
          <p className="eyebrow">Centro de Ajuda Personagrama</p>
          <h1>Como podemos ajudar?</h1>
          <p className="lead">Encontre orientações para utilizar o Personagrama, acompanhar seu desenvolvimento e administrar a plataforma.</p>
          <SearchBar />
        </div>
      </section>

      <section className="page-shell home-section" aria-labelledby="profile-heading">
        <div className="section-heading">
          <p className="eyebrow">Escolha sua experiência</p>
          <h2 id="profile-heading">Como você utiliza o Personagrama?</h2>
        </div>
        <div className="profile-grid">
          {profiles.map((profile) => (
            <Link
              key={profile}
              className="profile-card"
              to={profileHomePath(profile)}
              onClick={() => onChooseProfile(profile)}
            >
              <span className="profile-card-kicker">Sou</span>
              <strong>{PROFILE_LABEL[profile]}</strong>
              <span>{profileCopy[profile]}</span>
              <span className="card-link">Ver ajuda →</span>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}
